import { render } from "./AccessoriesPanel.vue?vue&type=template&id=b2dfae56"
import script from "./AccessoriesPanel.vue?vue&type=script&lang=js"
export * from "./AccessoriesPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__